/**
 * Demo mode context — provides a route prefix for navigation components.
 * When in demo mode, all nav links are prefixed with /demo.
 */
import { createContext, useContext } from 'react';

interface DemoContextValue {
  isDemo: boolean;
  /** Prefix to prepend to absolute routes (e.g. "/demo" or "") */
  routePrefix: string;
}

export const DemoContext = createContext<DemoContextValue>({ isDemo: false, routePrefix: '' });

export const useDemoMode = () => useContext(DemoContext);
